import {EVENT_GAUGE_DATA,
  EVENT_LIQUID_FILL_DATA} from '../mutiation'

const state = {
  gauge: {
    crisisLevel: 0,
    crisisLevelZh: '',
    value: 0
  },
  liquidFill: {
    interveneLevel: '',
    interveneScore: 0
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  [EVENT_GAUGE_DATA] (state, data) {
    state.gauge = Object.assign({}, state.gauge, data, {
      value: data.crisisLevel * 20
    })
  },
  [EVENT_LIQUID_FILL_DATA] (state, data) {
    state.liquidFill = Object.assign({}, state.liquidFill, data)
  }
}
const getters = {

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/index/store/modules/event.js